<template>
    <v-container class="pt-0 pl-0 pb-0">
        <v-row v-if="type_view == 0">
            <v-col cols="3" v-for="debt in debts" :key="debt.id">
                <v-card>
                    <v-card-title class="debt-customer">
                        <span v-if="debt.type_document=='DNI'" class="debtor-name text-truncate" >
                            {{ debt.name }} {{ debt.surname }}
                        </span>
                        <span v-else class="debtor-name text-truncate" >{{ debt.name }}</span>
                        
                    </v-card-title>
                    <v-card-subtitle>
                        <span class="caption font-weight-medium">{{ debt.type_document }}: {{ debt.document }}</span>
                    </v-card-subtitle>
                    <v-card-text >
                        <div class="info-debt">
                            <template>
                                <v-row>
                                    <v-col cols="6">
                                        <span class="span-block subtitle-2">Deuda Total</span>
                                        <span class="span-block debt-amount text-red">{{ debt.total_debt | currency('S/ ')}}</span>
                                    </v-col>
                                    <v-col cols="6">
                                        <span class="span-block subtitle-2">Monto Pagado</span>
                                        <span class="span-block debt-amount text-green">{{ debt.paid_debt | currency('S/ ')}}</span>
                                    </v-col>
                                </v-row>
                            </template>
                        </div>
                    </v-card-text>
                    <v-card-actions>
                        <div class="btn-view-account">
                            <v-btn small outlined color="#3f51b5" 
                                @click="handleViewDebtDetail(debt)"
                                v-if="verifyPermission('ver_detalle_deudas')">
                                Ver
                            </v-btn>
                        </div>                        
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>

        <v-row v-if="type_view != 0">
            <v-col cols="12" class="pt-0 pr-0">
                <v-card>
                    <v-data-table
                        class="wost-table"
                        :headers="headers"
                        :items="debts"
                        item-key="id"
                        height="63vh"
                        fixed-header
                    >
                        <template v-slot:item.name="{item}">
                            <span v-if="item.type_document=='DNI'">
                                {{ item.name }} {{ item.surname }}
                            </span>
                            <span v-else>{{ item.name }}</span>
                        </template>

                        <template v-slot:item.type="{item}">
                            <span v-if="item.type_document=='DNI'">
                                Natural
                            </span>
                            <span v-else>Jurídico</span>
                        </template>

                        <template v-slot:item.document="{item}">
                            {{ item.document }}
                        </template>

                        <template v-slot:item.total_debt="{item}">
                            <span class="text-red">{{ item.total_debt | currency('S/') }}</span>
                        </template>

                        <template v-slot:item.paid_debt="{item}">
                            <span class="text-green">{{ item.paid_debt | currency('S/') }}</span>
                        </template>

                        <template v-slot:item.action="{item}">
                            <v-btn small outlined color="#3f51b5" 
                                @click="handleViewDebtDetail(item)"
                                v-if="verifyPermission('ver_detalle_deudas')">
                                Ver
                            </v-btn>
                        </template>
                    </v-data-table>

                </v-card>               

            </v-col>
        </v-row>
        
        <debt-detail ref="debtDetail"></debt-detail>
    </v-container>   
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'

import DebtDetail from './DebtDetail'

export default {
    name: 'CardDebt',
    components: {
        DebtDetail
    },
    data() {
        return {
            headers: [
                { text: 'Cliente', value: 'name', align: 'left', sortable: false, class: 'header-table'},
                { text: 'Tipo', value: 'type', align: 'left', sortable: false, class: 'header-table'},
                { text: 'Documento', value: 'document', align: 'left', sortable: false, class: 'header-table' },
                { text: 'Deuda Total', value: 'total_debt', align: 'left', sortable: false, class: 'header-table' },
                { text: 'Monto Pagado', value: 'paid_debt', align: 'left', sortable: false, class: 'header-table' },
                { text: '', value: 'action', align: 'left', sortable: false, class: 'header-table' }
            ],
        }
    },
    computed: {
        ...mapState('debts', [
            'debts',
            'customerSelected',
            'type_view'
        ]),
    },
    methods: {
        ...mapActions('debts', [
            'getDebts',
            'runSetCustomerSelected',
            'getDebtsByCustomer',
            'getTotalAmount',
            'runSetTypeView'
        ]),
        handleViewDebtDetail(debt){
            this.runSetCustomerSelected(null)
            this.runSetCustomerSelected(debt)
            this.getDebtsByCustomer()
            this.$refs.debtDetail.showForm('Detalle de cuentas por cobrar')
        },
        verifyPermission(permission) {
            return this.$hasPermision(permission)
        }
    },
    mounted() {
        this.getDebts()
        this.getTotalAmount()
        this.runSetTypeView(0)
    }
}
</script>

<style>
.span-block{
    display: block;
}

.debt-amount{
    font-weight: bold;
}

.info-debt{
    background-color: #E3F2FD;
    padding: 5px;
    border-radius: 2px;
    text-align: center;
}

.debt-customer{
    font-size: 14px !important;
    text-transform: uppercase;
}

.debtor-name{
    width: 80%;
}

.btn-view-account{
    text-align: right;
    display: block;
    width: 100%;
}
</style>